module.exports = __webpack_public_path__ + "img/Gif_web4.eab6f933.gif";